import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { DELETE_USER_MUTATION } from '../graphql/mutations/deleteUser';
import { GET_USERS } from '../graphql/queries/getUsers';

interface DeleteUser {
  email: string;
}

export const useDeleteUser = () => {
  const [deleteUserMutation] = useMutation(DELETE_USER_MUTATION, {
    refetchQueries: [{ query: GET_USERS }]
  });

  const deleteUser = async ({ email }: DeleteUser) => {
    const variables = {
      userDeleteDto: {
        email
      }
    };

    try {
      await deleteUserMutation({ variables });
      toast.success('User deleted successfully!');
      return { error: null };
    } catch (error) {
      toast.error('There was an error deleting the user.');
      return { error };
    }
  };

  return { deleteUser };
};
